import { gql } from 'graphql-request'

export const DECLINE_ORG_INVITE_MUTATION = gql`
  mutation DeclineOrgInvite($inviteId: uuid!, $profileId: uuid) {
    invite: declineOrgInvite(inviteId: $inviteId, profileId: $profileId)
  }
`
